import {minutesToMilliseconds} from 'date-fns'

export const releaseAnnouncementUrl =
  'https://www.sanity.io/blog/sanity-ai-assist-announcement?utm_source=sanity-assist-plugin&utm_medium=organic_social&utm_campaign=ai-assist&utm_content='

export const instructionGuideUrl =
  'https://sanity.io/guides/getting-started-with-ai-assist-instructions?utm_source=sanity-assist-plugin&utm_medium=organic_social&utm_campaign=ai-assist&utm_content='

export const giveFeedbackUrl = 'https://forms.gle/Kwz7CThxGeA2GiEU8'

export const salesUrl =
  'https://www.sanity.io/contact/sales?utm_source=sanity-assist-plugin&utm_medium=organic_social&utm_campaign=ai-assist&utm_content='

export const packageName = '@sanity/assist'

export const pluginTitle = 'Sanity AI Assist'

export const pluginTitleShort = 'AI Assist'

export const maxHistoryVisibilityMs = minutesToMilliseconds(30)
